import { getLevelLabel } from '@app/src/pages/Assessments/Assessment/utils'
import type Assessment from '@app/src/types/assessment'
import { AssessmentLevelNamesType, AssessmentType } from '@app/src/types/resourceExplorer'
import { LabelFormat } from '@app/src/utils/assessmentLevelTranslations'
import { KeyboardArrowDown } from '@mui/icons-material'
import { Box, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface AssessmentStatusChipProps {
  assessment: Assessment
}

const AssessmentStatusChip: React.FC<AssessmentStatusChipProps> = ({ assessment }) => {
  const { formatMessage } = useIntl()
  const theme = useTheme()

  const assessmentType = assessment.assessmentTemplate?.assessmentType ?? AssessmentType.StandardAssessment
  const totalLevels = assessment.assessmentTemplate?.levels ?? 5
  const levelNamesType = assessment.assessmentTemplate?.levelNamesType ?? AssessmentLevelNamesType.Intervals
  const currentLevel = assessment.totalLevel ?? 0

  const getBackgroundColor = () => {
    if (totalLevels === 3) {
      if (currentLevel === 1) return theme.palette.error.light
      if (currentLevel === 2) return theme.palette.warning.light
      if (currentLevel === 3) return theme.palette.success.light
    } else {
      if (currentLevel === 1) return theme.palette.error.light
      if (currentLevel === 2) return theme.palette.error.light
      if (currentLevel === 3) return theme.palette.warning.light
      if (currentLevel === 4) return theme.palette.success.light
      if (currentLevel === 5) return theme.palette.success.light
    }
    return theme.palette.grey[100]
  }

  const bgColor = getBackgroundColor()
  const levelLabel = getLevelLabel(
    currentLevel,
    totalLevels,
    assessmentType,
    levelNamesType,
    formatMessage,
    LabelFormat.Basic,
  )

  return (
    <Box display="flex" flexDirection="column" alignItems="center" height="34px">
      <Box
        bgcolor={bgColor}
        borderRadius="17px"
        height="28px"
        px="12px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="button" sx={{ color: '#111' }}>
          {levelLabel}
        </Typography>
      </Box>
      {/* Arrow */}
      <KeyboardArrowDown sx={{ color: bgColor, fontSize: '0.75rem', marginTop: '-1px' }} />
    </Box>
  )
}

export default AssessmentStatusChip
